var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { useRecoilState } from 'recoil';
import { ButtonBorderedKVBase, Loading, loginFlowUserState } from '@/presentation/components';
import Styles from './login-styles.scss';
import { AsSchoolIcon, AsStudentIcon } from '@/presentation/components/icons/login-icons';
import { Auth } from 'aws-amplify';
const ChooseRole = ({ completeLogin }) => {
    const [internalLoading, setInternalLoading] = useState(false);
    const onBack = () => __awaiter(void 0, void 0, void 0, function* () {
        setInternalLoading(true);
        try {
            yield Auth.signOut();
        }
        catch (e) {
            console.error(e);
        }
        finally {
            setInternalLoading(false);
            window.location.href = '/';
        }
    });
    const [loginFlowUser] = useRecoilState(loginFlowUserState);
    const setLocalUserRole = (roleDescription) => __awaiter(void 0, void 0, void 0, function* () {
        // localStorage.setItem(ROLE_DESCRIPTION_KEY, roleDescription);
        setInternalLoading(true);
        yield completeLogin(loginFlowUser, roleDescription);
        setInternalLoading(false);
    });
    return (React.createElement("div", { className: Styles.formClass },
        React.createElement("div", { className: Styles.mainPartAEChoose },
            React.createElement("h1", null, "How do you want to continue?"),
            internalLoading && React.createElement(Loading, { noText: true, size: 30 }),
            React.createElement("div", { className: Styles.boxHrFull }),
            React.createElement(InternalItem, { icon: React.createElement(AsStudentIcon, null), title: 'As a Student', description: 'Start learning finance!', onCustomClick: () => __awaiter(void 0, void 0, void 0, function* () { return setLocalUserRole('Student'); }) }),
            React.createElement("div", { className: Styles.boxHrFull }),
            React.createElement(InternalItem, { icon: React.createElement(AsSchoolIcon, null), title: 'As a School Admin', description: 'Review lesson plans and manage your students', onCustomClick: () => __awaiter(void 0, void 0, void 0, function* () { return setLocalUserRole('Client'); }) }),
            React.createElement("div", { className: Styles.boxHrFull }),
            React.createElement(ButtonBorderedKVBase, { type: "button", onClick: onBack, loading: internalLoading }, "Back"))));
};
const InternalItem = ({ icon, title, description, onCustomClick, loading = false }) => {
    const handleOnClick = () => {
        if (loading || !onCustomClick)
            return;
        onCustomClick();
    };
    return (React.createElement("div", { className: Styles.internalItem, onClick: handleOnClick },
        React.createElement("div", { className: Styles.item1 }, icon),
        React.createElement("div", { className: Styles.item2 },
            React.createElement("div", { className: Styles.item21 }, title),
            React.createElement("div", { className: Styles.item22 }, description)),
        React.createElement("div", { className: Styles.item3 },
            React.createElement("svg", { width: "24", height: "25", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("path", { d: "M8.91016 20.42L15.4302 13.9C16.2002 13.13 16.2002 11.87 15.4302 11.1L8.91016 4.58002", stroke: "#454957", strokeWidth: "1.5", strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round" })))));
};
export default ChooseRole;
